var _defs, _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgIconHomeSelected = function SvgIconHomeSelected(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.002,
    height: 20,
    viewBox: "0 0 20.002 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1a3670;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41,163v-4H39v4H32v-9.187l-.59.593L30,152.992,40,143l8,8v0l2,2h0l-1.415,1.413L48,153.832V163Zm5-2v-9.168l-6.009-6.008L34,151.813V161h3v-4h6v4Z",
    transform: "translate(-30 -143)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHomeSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_home_selected.2134c676.svg";
export { ForwardRef as ReactComponent };